import { ResolveFn } from '@angular/router';
import { AccountRoutingRouteNames } from '@pxl/route-names';

export const veterinarianLinkageRequestResolver: ResolveFn<boolean> = (route, state) => {
    const url = state.url;
    return (
        url.includes(AccountRoutingRouteNames.VeterinarianLinkageRequestRegistrationStart) ||
        url.includes(AccountRoutingRouteNames.VeterinarianLinkageRequestWithRegistrationSuccess)
    );
};
